<template>
  <div :class="[colWidthClass, {'is-invalid': hasError}]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    colWidthClass: {
      type: String,
      required: true
    },

    hasError: {
      type: Boolean,
      default: false
    }
  }

}
</script>
